import React from 'react';

import config from 'configs/app';
import NavigationDesktop from 'ui/snippets/navigation/vertical/NavigationDesktop';

const SideBar = () => {
  if (config.UI.navigation.layout === 'horizontal') {
    return null;
  }

  return <NavigationDesktop/>;
};

export default React.memo(SideBar);
